// constants.js
export const AVAILABLE = [
    { text: "启用", value: "1" },
    { text: "停用", value: "0" },
]

export const PRODUCTTYPE = [
    { text: "普通商品", value: "1" },
    { text: "组合商品", value: "2" },
]

export const PURCHASE_ORDER_STATUS = [
    { text: "待审核", value: "0" },
    { text: "审核通过", value: "3" },
    { text: "审核拒绝", value: "6" },
]
export const PRODUCT_STOCK_BIZ_TYPE = [
    { text: "采购入库", value: 1 },
    { text: "采购退货出库", value: 2 },
    { text: "销售出库", value: 3 },
    { text: "销售退货入库", value: 4 },
    { text: "零售出库", value: 5 },
    { text: "零售退货入库", value: 6 },
    { text: "盘点入库", value: 7 },
    { text: "盘点出库", value: 8 },
    { text: "库存成本调整", value: 9 },
    { text: "库存调整", value: 10 },
    { text: "仓库调拨", value: 11 },
    { text: "库存初始化", value: 12 },
    { text: "积分兑换出库", value: 13 },
    { text: "新零售出库", value: 14 },
    { text: "新零售退货入库", value: 15 },
]
export const SETTLE_STATUS = [
    { text: "未结算", value: "0" },
    { text: "结算中", value: "1" },
    { text: "已结算", value: "3" },
    { text: "无需结算", value: "6" },
]

// 盘点单状态
export const TAKE_STOCK_SHEET_STATUS = [
    { text: "待审核", value: 0 },
    { text: "审核通过", value: 3 },
    { text: "审核拒绝", value: 6 },
]

// 盘点任务状态
export const TAKE_STOCK_PLAN_STATUS = [
    { text: "盘点任务生成", value: 0 },
    { text: "盘点差异生成", value: 6 },
    { text: "盘点完成", value: 9 },
    { text: "盘点已作废", value: 12 },
]

// 盘点类别
export const TAKE_STOCK_PLAN_TYPE = [
    { text: "全场盘点", value: 0 },
    { text: "单品盘点", value: 1 },
    { text: "类目盘点", value: 2 },
    { text: "品牌盘点", value: 3 },
]

// 定义一个通用函数，传入常量数组和value，返回对应的text
export const getTextByValue = (array, value) => {
    const item = array.find(item => item.value == value);
    return item ? item.text : undefined;
}